/** Tab-separated `optionKey` + nombre de evento del hub (orden de registro esperado por el servidor). */
function splitHubRows(raw: string): ReadonlyArray<readonly [string, string]> {
  return raw
    .trim()
    .split("\n")
    .map((line) => {
      const [opt, ev] = line.split("\t");
      return [opt!, ev!] as const;
    });
}

export const SIMPLE_HUB_ON = splitHubRows(`
callRinging_On_Agent	CallRinging_On_Agent
callCreated	CallCreated
callAgent_Declined	CallAgent_Declined
callAnswered	CallAnswered
callTransferred	CallTransferred
callUnsuccessful_Transfer	CallUnsuccessful_Transfer
callHungup	CallHungup
callEnded	CallEnded
callVoicemail_Left	CallVoicemail_Left
callCommented	CallCommented
callTagged	CallTagged
callUntagged	CallUntagged
callAssigned	CallAssigned
callArchived	CallArchived
callHold	CallHold
callUnhold	CallUnhold
contactCreated	ContactCreated
contactDeleted	ContactDeleted
contactUpdated	ContactUpdated
numberCreated	NumberCreated
numberDeleted	NumberDeleted
numberOpened	NumberOpened
numberClosed	NumberClosed
userCreated	UserCreated
userDeleted	UserDeleted
userConnected	UserConnected
userDisconnected	UserDisconnected
userOpened	UserOpened
userClosed	UserClosed
userWut_Start	UserWut_Start
userWut_End	UserWut_End`);

export const GROUP_HUB_ON = splitHubRows(`
callRinging_On_Agent_GroupJoin	CallRinging_On_Agent_Group
callCreated_GroupJoin	CallCreated_Group
callAgent_Declined_GroupJoin	CallAgent_Declined_Group
callAnswered_GroupJoin	CallAnswered_Group
callTransferred_GroupJoin	CallTransferred_Group
callUnsuccessful_Transfer_GroupJoin	CallUnsuccessful_Transfer_Group
callHungup_GroupJoin	CallHungup_Group
callEnded_GroupJoin	CallEnded_Group
callVoicemail_Left_GroupJoin	CallVoicemail_Left_Group
callCommented_GroupJoin	CallCommented_Group
callTagged_GroupJoin	CallTagged_Group
callUntagged_GroupJoin	CallUntagged_Group
callAssigned_GroupJoin	CallAssigned_Group
callArchived_GroupJoin	CallArchived_Group
callHold_GroupJoin	CallHold_Group
callUnhold_GroupJoin	CallUnhold_Group
contactCreated_GroupJoin	ContactCreated_Group
contactDeleted_GroupJoin	ContactDeleted_Group
contactUpdated_GroupJoin	ContactUpdated_Group
numberCreated_GroupJoin	NumberCreated_Group
numberDeleted_GroupJoin	NumberDeleted_Group
numberOpened_GroupJoin	NumberOpened_Group
numberClosed_GroupJoin	NumberClosed_Group
userCreated_GroupJoin	UserCreated_Group
userDeleted_GroupJoin	UserDeleted_Group
userConnected_GroupJoin	UserConnected_Group
userDisconnected_GroupJoin	UserDisconnected_Group
userOpened_GroupJoin	UserOpened_Group
userClosed_GroupJoin	UserClosed_Group
userWut_Start_GroupJoin	UserWut_Start_Group
userWut_End_GroupJoin	UserWut_End_Group`);

/**
 * Keys ending in `_NumberJoin` name `hubOptions` for `conn.on(…)` on `*_Number` events.
 * Join de ámbito: `Call_NumbersUsers_MyJoin` (combinado) o `Call_Numbers_MyJoin` + `Call_Users_MyJoin`, o `call_Numbers_AllJoin`, o fila atómica;
 * ver `shouldRegisterNumberHubOn` en `monitor-hub.ts`.
 */
export const NUMBER_HUB_ON = splitHubRows(`
callRinging_On_Agent_NumberJoin	CallRinging_On_Agent_Number
callCreated_NumberJoin	CallCreated_Number
callAgent_Declined_NumberJoin	CallAgent_Declined_Number
callAnswered_NumberJoin	CallAnswered_Number
callTransferred_NumberJoin	CallTransferred_Number
callUnsuccessful_Transfer_NumberJoin	CallUnsuccessful_Transfer_Number
callHungup_NumberJoin	CallHungup_Number
callEnded_NumberJoin	CallEnded_Number
callVoicemail_Left_NumberJoin	CallVoicemail_Left_Number
callCommented_NumberJoin	CallCommented_Number
callTagged_NumberJoin	CallTagged_Number
callUntagged_NumberJoin	CallUntagged_Number
callAssigned_NumberJoin	CallAssigned_Number
callArchived_NumberJoin	CallArchived_Number
callHold_NumberJoin	CallHold_Number
callUnhold_NumberJoin	CallUnhold_Number
contactCreated_NumberJoin	ContactCreated_Number
contactDeleted_NumberJoin	ContactDeleted_Number
contactUpdated_NumberJoin	ContactUpdated_Number
numberCreated_NumberJoin	NumberCreated_Number
numberDeleted_NumberJoin	NumberDeleted_Number
numberOpened_NumberJoin	NumberOpened_Number
numberClosed_NumberJoin	NumberClosed_Number
userCreated_NumberJoin	UserCreated_Number
userDeleted_NumberJoin	UserDeleted_Number
userConnected_NumberJoin	UserConnected_Number
userDisconnected_NumberJoin	UserDisconnected_Number
userOpened_NumberJoin	UserOpened_Number
userClosed_NumberJoin	UserClosed_Number
userWut_Start_NumberJoin	UserWut_Start_Number
userWut_End_NumberJoin	UserWut_End_Number`);

/** Tab-separated option key + `invoke` literal (same block order as `configureConnection` in reference). */
function splitInvokeRows(raw: string): ReadonlyArray<readonly [string, string]> {
  return raw
    .trim()
    .split("\n")
    .map((line) => {
      const [opt, inv] = line.split("\t");
      return [opt!, inv!] as const;
    });
}

export const HUB_INVOKE_ROWS = splitInvokeRows(`
callRinging_On_Agent_GroupJoin	CallRinging_On_Agent_GroupJoin
callCreated_GroupJoin	CallCreated_GroupJoin
callAgent_Declined_GroupJoin	CallAgent_Declined_GroupJoin
callAnswered_GroupJoin	CallAnswered_GroupJoin
callTransferred_GroupJoin	CallTransferred_GroupJoin
callUnsuccessful_Transfer_GroupJoin	CallUnsuccessful_Transfer_GroupJoin
callHungup_GroupJoin	CallHungup_GroupJoin
callEnded_GroupJoin	CallEnded_GroupJoin
callVoicemail_Left_GroupJoin	CallVoicemail_Left_GroupJoin
callCommented_GroupJoin	CallCommented_GroupJoin
callTagged_GroupJoin	CallTagged_GroupJoin
callUntagged_GroupJoin	CallUntagged_GroupJoin
callAssigned_GroupJoin	CallAssigned_GroupJoin
callArchived_GroupJoin	CallArchived_GroupJoin
callHold_GroupJoin	CallHold_GroupJoin
callUnhold_GroupJoin	CallUnhold_GroupJoin
callRinging_On_Agent_NumberJoin	CallRinging_On_Agent_NumberJoin
callCreated_NumberJoin	CallCreated_NumberJoin
callAgent_Declined_NumberJoin	CallAgent_Declined_NumberJoin
callAnswered_NumberJoin	CallAnswered_NumberJoin
callTransferred_NumberJoin	CallTransferred_NumberJoin
callUnsuccessful_Transfer_NumberJoin	CallUnsuccessful_Transfer_NumberJoin
callHungup_NumberJoin	CallHungup_NumberJoin
callEnded_NumberJoin	CallEnded_NumberJoin
callVoicemail_Left_NumberJoin	CallVoicemail_Left_NumberJoin
callCommented_NumberJoin	CallCommented_NumberJoin
callTagged_NumberJoin	CallTagged_NumberJoin
callUntagged_NumberJoin	CallUntagged_NumberJoin
callAssigned_NumberJoin	CallAssigned_NumberJoin
callArchived_NumberJoin	CallArchived_NumberJoin
callHold_NumberJoin	CallHold_NumberJoin
callUnhold_NumberJoin	CallUnhold_NumberJoin
contactCreated_GroupJoin	ContactCreated_GroupJoin
contactDeleted_GroupJoin	ContactDeleted_GroupJoin
contactUpdated_GroupJoin	ContactUpdated_GroupJoin
numberCreated_GroupJoin	NumberCreated_GroupJoin
numberDeleted_GroupJoin	NumberDeleted_GroupJoin
numberOpened_GroupJoin	NumberOpened_GroupJoin
numberClosed_GroupJoin	NumberClosed_GroupJoin
userCreated_GroupJoin	UserCreated_GroupJoin
userDeleted_GroupJoin	UserDeleted_GroupJoin
userConnected_GroupJoin	UserConnected_GroupJoin
userDisconnected_GroupJoin	UserDisconnected_GroupJoin
userOpened_GroupJoin	UserOpened_GroupJoin
userClosed_GroupJoin	UserClosed_GroupJoin
userWut_Start_GroupJoin	UserWut_Start_GroupJoin
userWut_End_GroupJoin	UserWut_End_GroupJoin
call_Numbers_AllJoin	Call_Numbers_AllJoin`);

/** Invokes `Leave` de alcance grupo (sin argumentos); paridad `AirCallHubClient` C#. */
export const HUB_INVOKE_LEAVE_GROUP_ROWS = splitInvokeRows(`
callRinging_On_Agent_GroupLeave	CallRinging_On_Agent_GroupLeave
callCreated_GroupLeave	CallCreated_GroupLeave
callAgent_Declined_GroupLeave	CallAgent_Declined_GroupLeave
callAnswered_GroupLeave	CallAnswered_GroupLeave
callTransferred_GroupLeave	CallTransferred_GroupLeave
callUnsuccessful_Transfer_GroupLeave	CallUnsuccessful_Transfer_GroupLeave
callHungup_GroupLeave	CallHungup_GroupLeave
callEnded_GroupLeave	CallEnded_GroupLeave
callVoicemail_Left_GroupLeave	CallVoicemail_Left_GroupLeave
callCommented_GroupLeave	CallCommented_GroupLeave
callTagged_GroupLeave	CallTagged_GroupLeave
callUntagged_GroupLeave	CallUntagged_GroupLeave
callAssigned_GroupLeave	CallAssigned_GroupLeave
callArchived_GroupLeave	CallArchived_GroupLeave
callHold_GroupLeave	CallHold_GroupLeave
callUnhold_GroupLeave	CallUnhold_GroupLeave
contactCreated_GroupLeave	ContactCreated_GroupLeave
contactDeleted_GroupLeave	ContactDeleted_GroupLeave
contactUpdated_GroupLeave	ContactUpdated_GroupLeave
numberCreated_GroupLeave	NumberCreated_GroupLeave
numberDeleted_GroupLeave	NumberDeleted_GroupLeave
numberOpened_GroupLeave	NumberOpened_GroupLeave
numberClosed_GroupLeave	NumberClosed_GroupLeave
userCreated_GroupLeave	UserCreated_GroupLeave
userDeleted_GroupLeave	UserDeleted_GroupLeave
userConnected_GroupLeave	UserConnected_GroupLeave
userDisconnected_GroupLeave	UserDisconnected_GroupLeave
userOpened_GroupLeave	UserOpened_GroupLeave
userClosed_GroupLeave	UserClosed_GroupLeave
userWut_Start_GroupLeave	UserWut_Start_GroupLeave
userWut_End_GroupLeave	UserWut_End_GroupLeave`);

/** Invokes `Leave` de alcance número por tipo de evento (sin argumentos). */
export const HUB_INVOKE_LEAVE_NUMBER_ROWS = splitInvokeRows(`
callRinging_On_Agent_NumberLeave	CallRinging_On_Agent_NumberLeave
callCreated_NumberLeave	CallCreated_NumberLeave
callAgent_Declined_NumberLeave	CallAgent_Declined_NumberLeave
callAnswered_NumberLeave	CallAnswered_NumberLeave
callTransferred_NumberLeave	CallTransferred_NumberLeave
callUnsuccessful_Transfer_NumberLeave	CallUnsuccessful_Transfer_NumberLeave
callHungup_NumberLeave	CallHungup_NumberLeave
callEnded_NumberLeave	CallEnded_NumberLeave
callVoicemail_Left_NumberLeave	CallVoicemail_Left_NumberLeave
callCommented_NumberLeave	CallCommented_NumberLeave
callTagged_NumberLeave	CallTagged_NumberLeave
callUntagged_NumberLeave	CallUntagged_NumberLeave
callAssigned_NumberLeave	CallAssigned_NumberLeave
callArchived_NumberLeave	CallArchived_NumberLeave
callHold_NumberLeave	CallHold_NumberLeave
callUnhold_NumberLeave	CallUnhold_NumberLeave`);

/**
 * Invokes `*NumbersJoin` / `*NumbersLeave` con segundo argumento (`JoinNumbers` en C#);
 * el embedder pasa `numbersJoinInvokePayload` en `MonitorHubOptions`.
 */
export const HUB_INVOKE_NUMBERS_BATCH_ROWS = splitInvokeRows(`
callRinging_On_Agent_NumbersJoin	CallRinging_On_Agent_NumbersJoin
callCreated_NumbersJoin	CallCreated_NumbersJoin
callAgent_Declined_NumbersJoin	CallAgent_Declined_NumbersJoin
callAnswered_NumbersJoin	CallAnswered_NumbersJoin
callTransferred_NumbersJoin	CallTransferred_NumbersJoin
callUnsuccessful_Transfer_NumbersJoin	CallUnsuccessful_Transfer_NumbersJoin
callHungup_NumbersJoin	CallHungup_NumbersJoin
callEnded_NumbersJoin	CallEnded_NumbersJoin
callVoicemail_Left_NumbersJoin	CallVoicemail_Left_NumbersJoin
callCommented_NumbersJoin	CallCommented_NumbersJoin
callTagged_NumbersJoin	CallTagged_NumbersJoin
callUntagged_NumbersJoin	CallUntagged_NumbersJoin
callAssigned_NumbersJoin	CallAssigned_NumbersJoin
callArchived_NumbersJoin	CallArchived_NumbersJoin
callHold_NumbersJoin	CallHold_NumbersJoin
callUnhold_NumbersJoin	CallUnhold_NumbersJoin
callRinging_On_Agent_NumbersLeave	CallRinging_On_Agent_NumbersLeave
callCreated_NumbersLeave	CallCreated_NumbersLeave
callAgent_Declined_NumbersLeave	CallAgent_Declined_NumbersLeave
callAnswered_NumbersLeave	CallAnswered_NumbersLeave
callTransferred_NumbersLeave	CallTransferred_NumbersLeave
callUnsuccessful_Transfer_NumbersLeave	CallUnsuccessful_Transfer_NumbersLeave
callHungup_NumbersLeave	CallHungup_NumbersLeave
callEnded_NumbersLeave	CallEnded_NumbersLeave
callVoicemail_Left_NumbersLeave	CallVoicemail_Left_NumbersLeave
callCommented_NumbersLeave	CallCommented_NumbersLeave
callTagged_NumbersLeave	CallTagged_NumbersLeave
callUntagged_NumbersLeave	CallUntagged_NumbersLeave
callAssigned_NumbersLeave	CallAssigned_NumbersLeave
callArchived_NumbersLeave	CallArchived_NumbersLeave
callHold_NumbersLeave	CallHold_NumbersLeave
callUnhold_NumbersLeave	CallUnhold_NumbersLeave`);

/** Nombre del evento snapshot según `AirCallHubClient` C# (`connection.On("UserNumbers", …)`). */
export const ON_USER_NUMBERS_EVENT = "UserNumbers";
